import type { OrderDetailsExtended } from 'app/src/model'
import { getStaticUsedCredit } from 'app/src/msw/shopping/initialSeed/credit'
import { apiBaseUrl } from 'app/src/msw/shopping/staticapi/apiBaseUrl'
import { updateStaticCredit } from 'app/src/msw/shopping/utils/updateCredit'
import type { shoppingApi } from 'app/src/services/welfareportal'
import type { CreditGetResult } from 'app/src/services/welfareportal/shopping-api'
import { http, HttpResponse } from 'msw'

export const getCredit = http.get<object, object, shoppingApi.CreditGetResult>(apiBaseUrl + '/credit', async () => {
  const activeMembership = JSON.parse(sessionStorage.getItem('selectedCampaign') || '{}')
  let credit: CreditGetResult = {
    pdrAssigned: 1000,
    fringeAssigned: 1000,
    info: ['note'],
    creditByServiceCategory: {
      welfareArt100: {
        total: 1000,
        available: 1000,
      },
      welfareArt51: {
        total: 1000,
        available: 1000,
      },
    },
  }

  const discountOrders = await (await fetch('./data/shopping/discountOrders.json')).json()
  const giftCardsOrders = await (await fetch('./data/shopping/giftCardsOrders.json')).json()
  const goodAndServiceOrders = await (await fetch('./data/shopping/goodAndServiceOrders.json')).json()
  const refundOrders = await (await fetch('./data/shopping/refundsOrders.json')).json()
  const vouchersOrders = await (await fetch('./data/shopping/vouchersOrders.json')).json()
  const transferOrders = await (await fetch('./data/shopping/transfersOrders.json')).json()

  const orders: OrderDetailsExtended[] = [
    ...(discountOrders?.items || []),
    ...(giftCardsOrders?.items || []),
    ...(goodAndServiceOrders?.items || []),
    ...(refundOrders?.items || []),
    ...(vouchersOrders?.items || []),
    ...(transferOrders?.items || []),
  ]

  console.log('MSW: getCredit - orders loaded', orders.length)

  const usedCredit = getStaticUsedCredit(orders, activeMembership?.membershipId || '')

  console.log('MSW: getCredit - usedCredit calculated', usedCredit)

  credit = updateStaticCredit(credit, usedCredit.art100Used, usedCredit.art51Used)

  return new HttpResponse(JSON.stringify(credit), {
    status: 200,
    headers: {
      'Content-Type': 'application/json',
    },
  })
})
